<template>
    <b-form @submit.prevent="fetch(formData)">
        <b-form-group label="ID">
            <b-form-input v-model="formData.reportId" disabled></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('report.viewLog.viewDate')">
            <b-form-select v-model="dateRangeType" :options="dateRangeTypes" v-on:change="dateRangeTypeSelected"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('general.fromDate')">
            <date-picker v-model="formData.startViewDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('general.toDate')">
            <date-picker v-model="formData.endViewDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('person.lastname')">
            <b-form-input v-model="formData.surname"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('general.role')">
            <b-form-input v-model="formData.userRole"></b-form-input>
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
import * as U from '@/utils/utils';

export default {
    name: 'ReportViewLogSearchForm',
    props: {
        fetch: Function
    },
    data () {
        return {
            dateRangeType: U.DateRangeType.LastDay,
            formData: {
                reportId: this.$route.params.id,
                startViewDate: null,
                endViewDate: null,
                startDate: null,
                endDate: null,
                surname: null,
                userRole: null
            },
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    mounted() {
        this.dateRangeTypeSelected();
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        },
        reportTypes: function () {
            return [
                { value: null, text: this.$t('general.select') },
                { value: 'REPORT_X', text: this.$t('report.types.REPORT_X') },
                { value: 'FISCAL_PERIOD_REPORT', text: this.$t('report.types.FISCAL_PERIOD_REPORT') },
                { value: 'CASHIER_REPORT', text: this.$t('report.types.CASHIER_REPORT') },
                { value: 'SECTION_REPORT', text: this.$t('report.types.SECTION_REPORT') }
            ]
        },
        dateRangeTypes: function () {
            return [
                { value: U.DateRangeType.LastHour, text: this.$t('general.lastHour') },
                { value: U.DateRangeType.Last12Hours, text: this.$t('general.last12Hours') },
                { value: U.DateRangeType.LastDay, text: this.$t('general.lastDay') }
            ]
        }
    },
    methods: {
        dateRangeTypeSelected() {
            const dateRange = U.getDateRange(this.dateRangeType);
            
            this.formData.startViewDate = dateRange.start;
            this.formData.endViewDate = dateRange.end;
        }
    }
}
</script>
